__turbopack_context__.v({
  "Blue": "dUCf-a_Blue",
  "CityName": "dUCf-a_CityName",
  "Col": "dUCf-a_Col",
  "Green": "dUCf-a_Green",
  "Header": "dUCf-a_Header",
  "LogoDesktop": "dUCf-a_LogoDesktop",
  "LogoMobile": "dUCf-a_LogoMobile",
  "MainNav": "dUCf-a_MainNav",
  "NavLink": "dUCf-a_NavLink",
  "NavRight": "dUCf-a_NavRight",
  "Pink": "dUCf-a_Pink",
  "SkipToMain": "dUCf-a_SkipToMain",
  "Yellow": "dUCf-a_Yellow",
});
